import React from 'react';
import './static/scss/new-age.scss';
import Menu from './screens/home/Menu'
import Header from './screens/home/Header'
import Screens from './screens/home/Screens'
import Card from './screens/home/Card'
import Footer from './screens/home/Footer'
import Downlaod from './screens/home/Downlaod'
import Last from './screens/home/Last'
import Donat from './screens/home/Donat'

function Router() {
    return (
        <div className="App">
            {/* <Menu></Menu> */}
            <Header></Header>
            {/* <Downlaod></Downlaod>
            <Screens></Screens>
            <Card></Card>
            <Donat></Donat>
            <Footer></Footer>
            <Last></Last> */}
        </div>
    );
}

export default Router;
